import { forwardRef, type Ref, type SVGProps } from "react";

function SvgBankGraySmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={52} height={52} fill="none" {...props}>
      <path fill="#D7DEE8" d="m26.007 10 21.429 8.926H4.578z" />
      <path fill="#D7DEE8" d="M2 18.926h48v.496H2z" />
      <path fill="#B4BECD" d="M2 42.229h48v.595H2zm.893-22.807h46.314v.595H2.893z" />
      <path fill="#D7DEE8" d="M2.595 20.017h46.909v.496H2.595z" />
      <path fill="#B4BECD" d="M4.083 20.513h43.934v1.488H4.083z" />
      <path fill="#D7DEE8" d="M4.083 40.744h43.934v1.488H4.083zM5.57 22h4.165v.694H5.57z" />
      <path fill="#B4BECD" d="M5.868 22.694h3.471v.595H5.868z" />
      <path fill="#D7DEE8" d="M5.57 38.859h4.165v.595H5.57z" />
      <path fill="#B4BECD" d="M5.174 39.455h4.959v1.289H5.174z" />
      <path fill="#D7DEE8" d="M6.165 23.289h2.876v15.57H6.165zM12.909 22h4.165v.694h-4.165z" />
      <path fill="#B4BECD" d="M13.207 22.694h3.471v.595h-3.471z" />
      <path fill="#D7DEE8" d="M12.909 38.859h4.165v.595h-4.165z" />
      <path fill="#B4BECD" d="M12.512 39.455h4.959v1.289h-4.959z" />
      <path fill="#D7DEE8" d="M13.504 23.289h2.876v15.57h-2.876zM20.248 22h4.165v.694h-4.165z" />
      <path fill="#B4BECD" d="M20.545 22.694h3.471v.595h-3.471z" />
      <path fill="#D7DEE8" d="M20.248 38.859h4.165v.595h-4.165z" />
      <path fill="#B4BECD" d="M19.851 39.455h4.959v1.289h-4.959z" />
      <path fill="#D7DEE8" d="M20.843 23.289h2.876v15.57h-2.876zM27.587 22h4.165v.694h-4.165z" />
      <path fill="#B4BECD" d="M27.884 22.694h3.471v.595h-3.471z" />
      <path fill="#D7DEE8" d="M27.587 38.859h4.165v.595h-4.165z" />
      <path fill="#B4BECD" d="M27.19 39.455h4.959v1.289H27.19z" />
      <path fill="#D7DEE8" d="M28.182 23.289h2.876v15.57h-2.876zM34.925 22h4.165v.694h-4.165z" />
      <path fill="#B4BECD" d="M35.223 22.694h3.471v.595h-3.471z" />
      <path fill="#D7DEE8" d="M34.925 38.859h4.165v.595h-4.165z" />
      <path fill="#B4BECD" d="M34.529 39.455h4.959v1.289h-4.959z" />
      <path fill="#D7DEE8" d="M35.52 23.289h2.876v15.57H35.52zM42.264 22h4.165v.694h-4.165z" />
      <path fill="#B4BECD" d="M42.562 22.694h3.471v.595h-3.471z" />
      <path fill="#D7DEE8" d="M42.264 38.859h4.165v.595h-4.165z" />
      <path fill="#B4BECD" d="M41.868 39.455h4.959v1.289h-4.959z" />
      <path fill="#D7DEE8" d="M42.859 23.289h2.876v15.57h-2.876z" />
      <mask
        id="bank-gray-small_svg__a"
        width={44}
        height={9}
        x={4}
        y={10}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path fill="#D7DEE8" d="m26.007 10 21.429 8.926H4.578z" />
      </mask>
      <g mask="url(#bank-gray-small_svg__a)">
        <path fill="#D7DEE8" d="m26.107 10 21.428 8.926H4.678z" />
      </g>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgBankGraySmall);
export default ForwardRef;
